import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CoreModule } from '@ridango/core';

import { RideHistoryActions, RideHistoryEpics, RideHistoryFacade } from './+state';
import { RideHistoryService } from './ride-history.service';

@NgModule({
    declarations: [],
    imports: [CoreModule, CommonModule],
    providers: [RideHistoryActions, RideHistoryFacade, RideHistoryEpics, RideHistoryService],
})
export class RideHistoryModule { }
